import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { startDocumentBatchPolling, stopDocumentBatchPolling } from '../../store/processDocument/documentBatch'
import { useAppDispatch, useAppSelector } from '../../store/hooks'

import { useZocksQuota } from '../../components/ScopedBlock/hooks'

import { DELTA_TRIAL_FEATURES } from '../Plan/DeltaTrial/DeltaTrialFeatures'
import { Upsell } from '../Plan/DeltaTrial/Upsell/Upsell'

import { DocumentBatchInitialization } from './Initialization/DocumentBatchInitialization'
import { DocumentBatchPoller } from './Poller/DocumentBatchPoller'
import { DocumentBatch } from './DocumentBatch/DocumentBatch'
import { selectShouldPollDocumentBatch } from '../../store/processDocument/processDocument'

export const DocumentBatchPage = () => {
  const { documentBatchId = null } = useParams()

  const { isFetching: quotasFetching, hasQuota, quotaSuccess } = useZocksQuota()

  if (!quotaSuccess && quotasFetching) {
    return null
  }

  if (!documentBatchId) {
    return null
  }

  const documentSummaryEnabled = hasQuota('ai.documentSummaryAgent.value')

  if (!documentSummaryEnabled) {
    return <Upsell feature={DELTA_TRIAL_FEATURES['processDocument']} />
  }

  return <DocumentBatchPageContent documentBatchId={documentBatchId} />
}

interface DocumentBatchPageContentProps {
  documentBatchId: string
}

const DocumentBatchPageContent: React.FC<DocumentBatchPageContentProps> = ({ documentBatchId }) => {
  const dispatch = useAppDispatch()

  const shouldPollDocumentBatch = useAppSelector(selectShouldPollDocumentBatch)

  useEffect(() => {
    if (shouldPollDocumentBatch) {
      dispatch(startDocumentBatchPolling())
    } else {
      dispatch(stopDocumentBatchPolling())
    }
  }, [dispatch, shouldPollDocumentBatch])

  return (
    <div className='full-size-content'>
      <DocumentBatchInitialization documentBatchId={documentBatchId} />
      <DocumentBatchPoller documentBatchId={documentBatchId} />
      <DocumentBatch />
    </div>
  )
}
